// Team Shell — dashboard, notifications page & announcements strings (prefix `dash.`).
const dash = {
  en: {
    "dash.subtitle": "Here's what's happening with your music today.",
    "dash.greet.morning": "Good morning",
    "dash.greet.afternoon": "Good afternoon",
    "dash.greet.evening": "Good evening",
    "dash.greet.night": "Up late",
    "dash.cta.fix": "Fix your release",
    "dash.cta.continueDraft": "Continue draft",
    "dash.viewAll": "View all",
    "dash.learnMore": "Learn more",
    "dash.sectionError": "Couldn't load this section",
    "dash.summaryError": "Couldn't load your stats",
    "dash.kpi.total": "Total earnings",
    "dash.kpi.totalHint": "Lifetime net, after splits",
    "dash.kpi.noRevenue": "No revenue reported yet",
    "dash.kpi.month": "This month",
    "dash.kpi.vsLastMonth": "vs last month",
    "dash.kpi.live": "Live releases",
    "dash.kpi.liveHint": "of {n} total releases",
    "dash.kpi.payout": "Next payout",
    "dash.kpi.payoutPending": "Withdrawal in progress",
    "dash.kpi.payoutReady": "Ready to withdraw",
    "dash.payout.minBalance": "Withdraw from {amount}",
    "dash.payout.kyc": "Verify your identity (KYC) to withdraw",
    "dash.payout.profile": "Complete your payout profile",
    "dash.payout.tax": "Add your tax information",
    "dash.payout.method": "Add a verified payout method",
    "dash.payout.weekly": "Weekly withdrawal limit reached",
    "dash.payout.notEligible": "Not eligible yet",
    "dash.chart.title": "Earnings",
    "dash.chart.lifetime": "Lifetime net earnings",
    "dash.chart.available": "Available balance",
    "dash.chart.period": "Chart period",
    "dash.chart.p6m": "6M",
    "dash.chart.p1y": "1Y",
    "dash.chart.pAll": "All",
    "dash.chart.netPay": "Your net share after splits",
    "dash.chart.emptyTitle": "No earnings yet",
    "dash.chart.emptyDesc": "Your monthly earnings will appear here once stores report revenue.",
    "dash.pipeline.title": "Release pipeline",
    "dash.pipeline.subtitle": "From draft to live in stores",
    "dash.pipeline.emptyTitle": "No releases yet",
    "dash.pipeline.emptyDesc": "Upload your first track and follow it all the way to the stores.",
    "dash.stage.draft": "Draft",
    "dash.stage.review": "In review",
    "dash.stage.approved": "Approved",
    "dash.stage.live": "Live",
    "dash.stage.needsEdits": "Needs edits",
    "dash.stage.rejected": "Rejected",
    "dash.stage.takenDown": "Taken down",
    "dash.upcoming.title": "Upcoming release",
    "dash.upcoming.badge": "Coming soon",
    "dash.upcoming.days": "Days",
    "dash.upcoming.hours": "Hours",
    "dash.upcoming.minutes": "Min",
    "dash.upcoming.seconds": "Sec",
    "dash.upcoming.smartLink": "Create Smart Link",
    "dash.upcoming.preSave": "Pre-Save",
    "dash.upcoming.details": "Details",
    "dash.ms.title": "Milestones",
    "dash.ms.subtitle": "Based on your real catalog and earnings",
    "dash.ms.live": "Live releases",
    "dash.ms.earnings": "Total earnings",
    "dash.ms.youtube": "YouTube views",
    "dash.ms.spotify": "Spotify followers",
    "dash.ms.next": "Next milestone: {n}",
    "dash.ms.maxed": "All milestones unlocked",
    "dash.ms.share": "Share",
    "dash.ms.shareTitle": "Milestone unlocked!",
    "dash.ms.shareDesc": "Download a story-sized card and share it with your fans.",
    "dash.ms.download": "Download for Instagram Story",
    "dash.ms.downloadError": "Couldn't create the image",
    "dash.ms.unlocked": "Milestone unlocked",
    "dash.setup.title": "Finish setting up your account",
    "dash.setup.subtitle": "{done} of {total} steps done",
    "dash.setup.dismiss": "Hide checklist",
    "dash.step.profile": "Complete your artist profile",
    "dash.step.profileDesc": "Add your name and country",
    "dash.step.payoutProfile": "Verify your payout profile",
    "dash.step.payoutProfileDesc": "Required to receive payments",
    "dash.step.payment": "Add a payout method",
    "dash.step.paymentDesc": "Bank account or PayPal",
    "dash.step.release": "Upload your first release",
    "dash.step.releaseDesc": "Share your music with the world",
    "dash.step.connections": "Connect your platforms",
    "dash.step.connectionsDesc": "Social and streaming profiles",
    "dash.notif.emptyDesc": "Release updates, payouts and support replies will show up here.",
    "dash.support.title": "Support tickets",
    "dash.support.new": "New ticket",
    "dash.support.emptyTitle": "No open tickets",
    "dash.support.emptyDesc": "Need help? Our team usually replies within a day.",
    "dash.ticket.open": "Open",
    "dash.ticket.pending": "Pending",
    "dash.ticket.waiting": "Awaiting your reply",
    "dash.ticket.resolved": "Resolved",
    "dash.ticket.closed": "Closed",
    "dash.feed.title": "What's new",
    "dash.cat.spotlight": "Artist Spotlight",
    "dash.cat.platform": "Platform",
    "dash.cat.dsp": "Store news",
    "dash.cat.campaign": "Campaign",
    "dash.cat.education": "Education",
    "dash.cat.general": "General",
    "dash.time.justNow": "Just now",
    "dash.time.minAgo": "{n} min ago",
    "dash.time.hrsAgo": "{n} h ago",
    "dash.time.yesterday": "Yesterday",
    "dash.time.daysAgo": "{n} days ago",
    "dash.notifPage.subtitle": "Everything that happened on your account",
    "dash.notifPage.unreadCount": "{n} unread",
    "dash.notifPage.filter": "Filter notifications",
    "dash.notifPage.all": "All",
    "dash.notifPage.unread": "Unread",
    "dash.notifPage.read": "Read",
    "dash.notifPage.allCategories": "All types",
    "dash.notifPage.catReleases": "Releases",
    "dash.notifPage.catFinance": "Finance",
    "dash.notifPage.catSupport": "Support",
    "dash.notifPage.catAccount": "Account",
    "dash.notifPage.today": "Today",
    "dash.notifPage.earlier": "Earlier",
    "dash.notifPage.noMatch": "Nothing here",
    "dash.notifPage.noMatchDesc": "No notifications match these filters.",
    "dash.notifPage.limitNote": "Showing your 50 most recent notifications.",
    "dash.ann.region": "Announcements",
    "dash.ann.label": "Announcement",
    "dash.ann.details": "Details",
    "dash.ann.dismiss": "Dismiss announcement",
    "dash.ann.gotIt": "Got it",
  },
  tr: {
    "dash.subtitle": "Müziğinde bugün neler oluyor, hepsi burada.",
    "dash.greet.morning": "Günaydın",
    "dash.greet.afternoon": "İyi günler",
    "dash.greet.evening": "İyi akşamlar",
    "dash.greet.night": "İyi geceler",
    "dash.cta.fix": "Yayınını düzenle",
    "dash.cta.continueDraft": "Taslağa devam et",
    "dash.viewAll": "Tümünü gör",
    "dash.learnMore": "Detaylar",
    "dash.sectionError": "Bu bölüm yüklenemedi",
    "dash.summaryError": "İstatistiklerin yüklenemedi",
    "dash.kpi.total": "Toplam kazanç",
    "dash.kpi.totalHint": "Split sonrası toplam net",
    "dash.kpi.noRevenue": "Henüz gelir raporlanmadı",
    "dash.kpi.month": "Bu ay",
    "dash.kpi.vsLastMonth": "geçen aya göre",
    "dash.kpi.live": "Yayındaki işler",
    "dash.kpi.liveHint": "toplam {n} yayından",
    "dash.kpi.payout": "Sonraki ödeme",
    "dash.kpi.payoutPending": "Çekim talebi işleniyor",
    "dash.kpi.payoutReady": "Çekime hazır",
    "dash.payout.minBalance": "{amount} itibarıyla çekebilirsin",
    "dash.payout.kyc": "Çekim için kimliğini doğrula (KYC)",
    "dash.payout.profile": "Ödeme profilini tamamla",
    "dash.payout.tax": "Vergi bilgilerini ekle",
    "dash.payout.method": "Doğrulanmış ödeme yöntemi ekle",
    "dash.payout.weekly": "Haftalık çekim limitine ulaşıldı",
    "dash.payout.notEligible": "Henüz uygun değil",
    "dash.chart.title": "Kazançlar",
    "dash.chart.lifetime": "Toplam net kazanç",
    "dash.chart.available": "Kullanılabilir bakiye",
    "dash.chart.period": "Grafik dönemi",
    "dash.chart.p6m": "6 Ay",
    "dash.chart.p1y": "1 Yıl",
    "dash.chart.pAll": "Tümü",
    "dash.chart.netPay": "Split sonrası net payın",
    "dash.chart.emptyTitle": "Henüz kazanç yok",
    "dash.chart.emptyDesc": "Mağazalar gelir raporladığında aylık kazançların burada görünecek.",
    "dash.pipeline.title": "Yayın süreci",
    "dash.pipeline.subtitle": "Taslaktan mağazalara",
    "dash.pipeline.emptyTitle": "Henüz yayının yok",
    "dash.pipeline.emptyDesc": "İlk parçanı yükle ve mağazalara kadar her adımı takip et.",
    "dash.stage.draft": "Taslak",
    "dash.stage.review": "İncelemede",
    "dash.stage.approved": "Onaylandı",
    "dash.stage.live": "Yayında",
    "dash.stage.needsEdits": "Düzenleme gerekli",
    "dash.stage.rejected": "Reddedildi",
    "dash.stage.takenDown": "Kaldırıldı",
    "dash.upcoming.title": "Yaklaşan yayın",
    "dash.upcoming.badge": "Çok yakında",
    "dash.upcoming.days": "Gün",
    "dash.upcoming.hours": "Saat",
    "dash.upcoming.minutes": "Dk",
    "dash.upcoming.seconds": "Sn",
    "dash.upcoming.smartLink": "Smart Link oluştur",
    "dash.upcoming.preSave": "Ön Kayıt",
    "dash.upcoming.details": "Detaylar",
    "dash.ms.title": "Kilometre taşları",
    "dash.ms.subtitle": "Gerçek katalog ve kazanç verilerine göre",
    "dash.ms.live": "Yayındaki işler",
    "dash.ms.earnings": "Toplam kazanç",
    "dash.ms.youtube": "YouTube izlenmesi",
    "dash.ms.spotify": "Spotify takipçisi",
    "dash.ms.next": "Sonraki hedef: {n}",
    "dash.ms.maxed": "Tüm hedefler tamamlandı",
    "dash.ms.share": "Paylaş",
    "dash.ms.shareTitle": "Yeni kilometre taşı!",
    "dash.ms.shareDesc": "Hikaye boyutunda kartı indir ve hayranlarınla paylaş.",
    "dash.ms.download": "Instagram Hikayesi için indir",
    "dash.ms.downloadError": "Görsel oluşturulamadı",
    "dash.ms.unlocked": "Kilometre taşı açıldı",
    "dash.setup.title": "Hesap kurulumunu tamamla",
    "dash.setup.subtitle": "{total} adımdan {done} tanesi tamam",
    "dash.setup.dismiss": "Listeyi gizle",
    "dash.step.profile": "Sanatçı profilini tamamla",
    "dash.step.profileDesc": "Adını ve ülkeni ekle",
    "dash.step.payoutProfile": "Ödeme profilini doğrula",
    "dash.step.payoutProfileDesc": "Ödeme almak için gerekli",
    "dash.step.payment": "Ödeme yöntemi ekle",
    "dash.step.paymentDesc": "Banka hesabı veya PayPal",
    "dash.step.release": "İlk yayınını yükle",
    "dash.step.releaseDesc": "Müziğini dünyayla paylaş",
    "dash.step.connections": "Platformlarını bağla",
    "dash.step.connectionsDesc": "Sosyal medya ve dijital müzik profilleri",
    "dash.notif.emptyDesc": "Yayın güncellemeleri, ödemeler ve destek yanıtları burada görünür.",
    "dash.support.title": "Destek talepleri",
    "dash.support.new": "Yeni talep",
    "dash.support.emptyTitle": "Açık talebin yok",
    "dash.support.emptyDesc": "Yardım mı lazım? Ekibimiz genelde bir gün içinde yanıtlar.",
    "dash.ticket.open": "Açık",
    "dash.ticket.pending": "Bekliyor",
    "dash.ticket.waiting": "Yanıtın bekleniyor",
    "dash.ticket.resolved": "Çözüldü",
    "dash.ticket.closed": "Kapatıldı",
    "dash.feed.title": "Neler oluyor?",
    "dash.cat.spotlight": "Sanatçı Vitrini",
    "dash.cat.platform": "Platform",
    "dash.cat.dsp": "Mağaza haberleri",
    "dash.cat.campaign": "Kampanya",
    "dash.cat.education": "Eğitim",
    "dash.cat.general": "Genel",
    "dash.time.justNow": "Az önce",
    "dash.time.minAgo": "{n} dk önce",
    "dash.time.hrsAgo": "{n} sa önce",
    "dash.time.yesterday": "Dün",
    "dash.time.daysAgo": "{n} gün önce",
    "dash.notifPage.subtitle": "Hesabında olan her şey",
    "dash.notifPage.unreadCount": "{n} okunmamış",
    "dash.notifPage.filter": "Bildirimleri filtrele",
    "dash.notifPage.all": "Tümü",
    "dash.notifPage.unread": "Okunmamış",
    "dash.notifPage.read": "Okunmuş",
    "dash.notifPage.allCategories": "Tüm türler",
    "dash.notifPage.catReleases": "Yayınlar",
    "dash.notifPage.catFinance": "Finans",
    "dash.notifPage.catSupport": "Destek",
    "dash.notifPage.catAccount": "Hesap",
    "dash.notifPage.today": "Bugün",
    "dash.notifPage.earlier": "Daha önce",
    "dash.notifPage.noMatch": "Burada bir şey yok",
    "dash.notifPage.noMatchDesc": "Bu filtrelere uyan bildirim yok.",
    "dash.notifPage.limitNote": "Son 50 bildirimin gösteriliyor.",
    "dash.ann.region": "Duyurular",
    "dash.ann.label": "Duyuru",
    "dash.ann.details": "Detaylar",
    "dash.ann.dismiss": "Duyuruyu kapat",
    "dash.ann.gotIt": "Anladım",
  },
  es: {
    "dash.subtitle": "Esto es lo que pasa hoy con tu música.",
    "dash.greet.morning": "Buenos días",
    "dash.greet.afternoon": "Buenas tardes",
    "dash.greet.evening": "Buenas noches",
    "dash.greet.night": "Trasnochando",
    "dash.cta.fix": "Corregir lanzamiento",
    "dash.cta.continueDraft": "Continuar borrador",
    "dash.viewAll": "Ver todo",
    "dash.learnMore": "Más información",
    "dash.sectionError": "No se pudo cargar esta sección",
    "dash.summaryError": "No se pudieron cargar tus estadísticas",
    "dash.kpi.total": "Ganancias totales",
    "dash.kpi.totalHint": "Neto acumulado tras splits",
    "dash.kpi.noRevenue": "Aún no hay ingresos reportados",
    "dash.kpi.month": "Este mes",
    "dash.kpi.vsLastMonth": "vs. mes anterior",
    "dash.kpi.live": "Lanzamientos activos",
    "dash.kpi.liveHint": "de {n} lanzamientos",
    "dash.kpi.payout": "Próximo pago",
    "dash.kpi.payoutPending": "Retiro en proceso",
    "dash.kpi.payoutReady": "Listo para retirar",
    "dash.payout.minBalance": "Retira a partir de {amount}",
    "dash.payout.kyc": "Verifica tu identidad (KYC) para retirar",
    "dash.payout.profile": "Completa tu perfil de pago",
    "dash.payout.tax": "Añade tu información fiscal",
    "dash.payout.method": "Añade un método de pago verificado",
    "dash.payout.weekly": "Límite semanal de retiros alcanzado",
    "dash.payout.notEligible": "Aún no disponible",
    "dash.chart.title": "Ganancias",
    "dash.chart.lifetime": "Ganancias netas acumuladas",
    "dash.chart.available": "Saldo disponible",
    "dash.chart.period": "Periodo del gráfico",
    "dash.chart.p6m": "6M",
    "dash.chart.p1y": "1A",
    "dash.chart.pAll": "Todo",
    "dash.chart.netPay": "Tu parte neta tras splits",
    "dash.chart.emptyTitle": "Aún no hay ganancias",
    "dash.chart.emptyDesc": "Tus ganancias mensuales aparecerán aquí cuando las tiendas reporten ingresos.",
    "dash.pipeline.title": "Flujo de lanzamientos",
    "dash.pipeline.subtitle": "Del borrador a las tiendas",
    "dash.pipeline.emptyTitle": "Aún no tienes lanzamientos",
    "dash.pipeline.emptyDesc": "Sube tu primera pista y síguela hasta las tiendas.",
    "dash.stage.draft": "Borrador",
    "dash.stage.review": "En revisión",
    "dash.stage.approved": "Aprobado",
    "dash.stage.live": "Publicado",
    "dash.stage.needsEdits": "Requiere cambios",
    "dash.stage.rejected": "Rechazado",
    "dash.stage.takenDown": "Retirado",
    "dash.upcoming.title": "Próximo lanzamiento",
    "dash.upcoming.badge": "Muy pronto",
    "dash.upcoming.days": "Días",
    "dash.upcoming.hours": "Horas",
    "dash.upcoming.minutes": "Min",
    "dash.upcoming.seconds": "Seg",
    "dash.upcoming.smartLink": "Crear Smart Link",
    "dash.upcoming.preSave": "Pre-Save",
    "dash.upcoming.details": "Detalles",
    "dash.ms.title": "Hitos",
    "dash.ms.subtitle": "Basados en tu catálogo y ganancias reales",
    "dash.ms.live": "Lanzamientos activos",
    "dash.ms.earnings": "Ganancias totales",
    "dash.ms.youtube": "Vistas en YouTube",
    "dash.ms.spotify": "Seguidores en Spotify",
    "dash.ms.next": "Próximo hito: {n}",
    "dash.ms.maxed": "Todos los hitos desbloqueados",
    "dash.ms.share": "Compartir",
    "dash.ms.shareTitle": "¡Hito desbloqueado!",
    "dash.ms.shareDesc": "Descarga una tarjeta en formato historia y compártela con tus fans.",
    "dash.ms.download": "Descargar para historia de Instagram",
    "dash.ms.downloadError": "No se pudo crear la imagen",
    "dash.ms.unlocked": "Hito desbloqueado",
    "dash.setup.title": "Termina de configurar tu cuenta",
    "dash.setup.subtitle": "{done} de {total} pasos completados",
    "dash.setup.dismiss": "Ocultar lista",
    "dash.step.profile": "Completa tu perfil de artista",
    "dash.step.profileDesc": "Añade tu nombre y país",
    "dash.step.payoutProfile": "Verifica tu perfil de pago",
    "dash.step.payoutProfileDesc": "Necesario para recibir pagos",
    "dash.step.payment": "Añade un método de pago",
    "dash.step.paymentDesc": "Cuenta bancaria o PayPal",
    "dash.step.release": "Sube tu primer lanzamiento",
    "dash.step.releaseDesc": "Comparte tu música con el mundo",
    "dash.step.connections": "Conecta tus plataformas",
    "dash.step.connectionsDesc": "Perfiles sociales y de streaming",
    "dash.notif.emptyDesc": "Aquí verás actualizaciones de lanzamientos, pagos y respuestas de soporte.",
    "dash.support.title": "Tickets de soporte",
    "dash.support.new": "Nuevo ticket",
    "dash.support.emptyTitle": "No hay tickets abiertos",
    "dash.support.emptyDesc": "¿Necesitas ayuda? Nuestro equipo suele responder en un día.",
    "dash.ticket.open": "Abierto",
    "dash.ticket.pending": "Pendiente",
    "dash.ticket.waiting": "Esperando tu respuesta",
    "dash.ticket.resolved": "Resuelto",
    "dash.ticket.closed": "Cerrado",
    "dash.feed.title": "Novedades",
    "dash.cat.spotlight": "Artista destacado",
    "dash.cat.platform": "Plataforma",
    "dash.cat.dsp": "Noticias de tiendas",
    "dash.cat.campaign": "Campaña",
    "dash.cat.education": "Formación",
    "dash.cat.general": "General",
    "dash.time.justNow": "Ahora mismo",
    "dash.time.minAgo": "hace {n} min",
    "dash.time.hrsAgo": "hace {n} h",
    "dash.time.yesterday": "Ayer",
    "dash.time.daysAgo": "hace {n} días",
    "dash.notifPage.subtitle": "Todo lo que pasó en tu cuenta",
    "dash.notifPage.unreadCount": "{n} sin leer",
    "dash.notifPage.filter": "Filtrar notificaciones",
    "dash.notifPage.all": "Todas",
    "dash.notifPage.unread": "Sin leer",
    "dash.notifPage.read": "Leídas",
    "dash.notifPage.allCategories": "Todos los tipos",
    "dash.notifPage.catReleases": "Lanzamientos",
    "dash.notifPage.catFinance": "Finanzas",
    "dash.notifPage.catSupport": "Soporte",
    "dash.notifPage.catAccount": "Cuenta",
    "dash.notifPage.today": "Hoy",
    "dash.notifPage.earlier": "Anteriores",
    "dash.notifPage.noMatch": "No hay nada aquí",
    "dash.notifPage.noMatchDesc": "Ninguna notificación coincide con estos filtros.",
    "dash.notifPage.limitNote": "Mostrando tus 50 notificaciones más recientes.",
    "dash.ann.region": "Anuncios",
    "dash.ann.label": "Anuncio",
    "dash.ann.details": "Detalles",
    "dash.ann.dismiss": "Cerrar anuncio",
    "dash.ann.gotIt": "Entendido",
  },
};

export default dash;
